import { render, staticRenderFns } from "./DashboardControll.vue?vue&type=template&id=d1765f1c"
import script from "./DashboardControll.vue?vue&type=script&lang=js"
export * from "./DashboardControll.vue?vue&type=script&lang=js"
import style0 from "./DashboardControll.vue?vue&type=style&index=0&id=d1765f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports